import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import SliderCollection from './molecules/SliderCollection';
import { Action, LargeText, ScrollAnimationParent } from '@studiometa/ui';
import Slider from './molecules/Slider';
import Search from './organisms/Search/index.js';
import HeaderSearch from './organisms/HeaderSearch/index.js';
import LocalSwitcher from './molecules/LocalSwitcher.js';


/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Slider,
      ScrollAnimationParent,
      SliderCollection,
      Action,
      Search,
      HeaderSearch,
      LargeText,
      LocalSwitcher,
      FullHeightProduct: (app) => importWhenVisible(
          () => import('./organisms/FullHeightProduct.js'),
          'FullHeightProduct',
          app
        ),
      BirthdayForm: (app) => importWhenVisible(
        () => import('./molecules/BirthdayForm.js'),
        'BirthdayForm',
        app
      )
    },
    log: true,
  };

  mounted() {
    this.$log('mounted');
  }

  onHeaderSearchShowSearch() {
    this.$children.Search[0].open();
  }
}

export default createApp(App, document.body);
